import React from 'react';
import ComingSoon from '@/components/shared/ComingSoonSection';
import './ExpensesPage.scss';

const ExpensesPage = () => {
  return (
    <div className="ExpensesPage">
      <ComingSoon title="ExpensesPage" />
    </div>
  );
};

export default ExpensesPage;